import React from 'react';
import { OtherSection, RootLayout } from 'common/components';
import { useLocation } from '@okapi/router-react';
import { Layout } from 'fronton-react';
import {
  KITCHEN_COLLECTIONS_LANDING_NAME,
  MODIFIED_KITCHEN_COLLECTIONS_BREADCRUMBS,
} from './kitchen-collections-constants';
import { CollectionsList, KitchenProjectBanner, OrderSteps, CollectionCards } from './components';

export const KitchenCollections = () => {
  const [path] = useLocation();
  const isCorner = path.includes('uglovye');

  return (
    <RootLayout customBreadcrumbs={MODIFIED_KITCHEN_COLLECTIONS_BREADCRUMBS} currentPage={path}>
      <Layout>
        <CollectionsList isCorner={isCorner} />
        <KitchenProjectBanner />
        <OrderSteps />
        <CollectionCards />
      </Layout>
      <OtherSection
        elementBlock="komplekty / catalogue / other"
        landingName={KITCHEN_COLLECTIONS_LANDING_NAME}
        promotionName="komplekty / catalogue_bottom"
      />
    </RootLayout>
  );
};
